<template>
  <div class="multitextbox">
    <div class="multi-title formtitle1">{{property.name}}<span v-if="property.checked" class="ischeck">*</span></div>
    <div class="multi-textarea">
      请填写
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>
<style scoped>
.mutil-text {
  font-size: 14px;
  color: #888;
  padding: 12px 15px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  min-height: 130px;
}
</style>

 